module.exports = __webpack_public_path__ + "img/3st_enterprise_app.0e86c2ae.png";